import { createSlice } from "@reduxjs/toolkit";
import { getAppLanguageCode } from "../constants/TranslationConstants";

const initialState = {
    chatList: [],
    unreadChatMsgCount: 0,
    isChatBubbleOpen: false,
    inComingChatBubbleMsg: {},
    // Translation UI state
    isTranslationPanelOpen: false,
    isAutoTranslateEnabled: false,
    selectedTranslationLanguage: getAppLanguageCode(),
    // Agent send message translation
    agentSendLanguage: "en",
};

const chatReducerSlice = createSlice({
    name: "chatReducer",
    initialState,
    reducers: {
        setChatList(state, action) {
            state.chatList = action.payload;
        },
        addChatMessage(state, action) {
            state.chatList.unshift(action.payload);
        },
        incrementUnreadChatMsgCount(state) {
            state.unreadChatMsgCount++;
        },
        resetUnreadChatMsgCount(state) {
            state.unreadChatMsgCount = 0;
        },
        setIsChatBubbleOpen(state, action) {
            state.isChatBubbleOpen = action.payload;
        },
        setInComingChatBubbleMsg(state, action) {
            state.inComingChatBubbleMsg = action.payload;
        },
        // Translation UI actions
        setIsTranslationPanelOpen(state, action) {
            state.isTranslationPanelOpen = action.payload;
        },
        setIsAutoTranslateEnabled(state, action) {
            state.isAutoTranslateEnabled = action.payload;
        },
        setSelectedTranslationLanguage(state, action) {
            state.selectedTranslationLanguage = action.payload;
        },
        setAgentSendLanguage(state, action) {
            state.agentSendLanguage = action.payload;
        },
        // Update translation for a specific message by messageId
        updateMessageTranslation(state, action) {
            const { messageId, translatedText, detectedLanguage, isTranslating, showOriginal } = action.payload;
            const messageIndex = state.chatList.findIndex((msg) => msg.messageId === messageId);
            if (messageIndex !== -1) {
                state.chatList[messageIndex] = {
                    ...state.chatList[messageIndex],
                    translatedText,
                    detectedLanguage,
                    isTranslating: isTranslating ?? false,
                    showOriginal: showOriginal ?? false,
                };
            }
        },
        // Toggle between original and translated text for a message using unique messageId
        toggleMessageOriginal(state, action) {
            const { messageId } = action.payload;
            const messageIndex = state.chatList.findIndex((msg) => msg.messageId === messageId);
            if (messageIndex !== -1) {
                state.chatList[messageIndex].showOriginal = !state.chatList[messageIndex].showOriginal;
            }
        },
        // Set translating state for a message by messageId
        setMessageTranslating(state, action) {
            const { messageId, isTranslating } = action.payload;
            const messageIndex = state.chatList.findIndex((msg) => msg.messageId === messageId);
            if (messageIndex !== -1) {
                state.chatList[messageIndex].isTranslating = isTranslating;
            }
        },
        resetChatReducer() {
            return initialState;
        },
    },
});

export const {
    setChatList,
    addChatMessage,
    incrementUnreadChatMsgCount,
    resetUnreadChatMsgCount,
    setIsChatBubbleOpen,
    setInComingChatBubbleMsg,
    setIsTranslationPanelOpen,
    setIsAutoTranslateEnabled,
    setSelectedTranslationLanguage,
    setAgentSendLanguage,
    updateMessageTranslation,
    toggleMessageOriginal,
    setMessageTranslating,
    resetChatReducer,
} = chatReducerSlice.actions;
export default chatReducerSlice.reducer;
